export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '5d57410d-662b-48fd-8b6c-6b343b64fa16',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'chubbendesa.alares',

  /**
  * Nombre de la app
  */
  appName: 'Chubb',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-SD0YYN2GBC',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: false,

  /** Registro habilitado o deshabilitado */
  registration: false,
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
  mailTransport: 'alares',
  brandName: 'Alares',
  appUrlTld: 'es',

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false
};
